import request from '@/utils/request'

// 库位列表
export function cargo_space_list (query) {
  return request({
    url: '/wms/warehouse/cargo_space/',
    method: 'get',
    params: query
  })
}
